import { combineReducers } from "redux";
import { authReducer } from "./auth.reducer";
import { courseReducer } from "./course.reducer";
import { topicReducer } from "./topic.reducer";
import { userAnswerReducer } from "./answer.reducer";
import { dashboardReducer } from "./dashboard.reducer";

export default combineReducers({
  auth: authReducer,
  courses: courseReducer,
  topics: topicReducer,
  answer: userAnswerReducer,
  dashboard: dashboardReducer,
});
